export enum StyleConstantsEnum {
  TitleFontFamily = '"Quicksand", sans-serif',
  TextFontFamily = '"Inter", sans-serif',
  CodeFontFamily = '"Courier Prime", sans-serif',
}
